import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogOptions } from 'app/models/confirm-dialog-options.models';

@Component({
  selector: 'app-confirm-multimessage-dialog',
  templateUrl: './confirm-multimessage-dialog.component.html',
  styleUrls: ['./confirm-multimessage-dialog.component.scss']
})
export class ConfirmMultiMessageDialogComponent {
  title: string;
  messages: any[];
  options: ConfirmDialogOptions;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    public _dialogRef: MatDialogRef<ConfirmMultiMessageDialogComponent>,
  ) {
    this.title = data.title;
    this.messages = data.messages;
    this.options = data.options;
  }

  onConfirm(): void {
    // Close the dialog, return true
    this._dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this._dialogRef.close(false);
  }
}
